import React, { useState, useEffect, useCallback } from 'react';
import { mergeClasses } from '@griffel/react';
import { useLocation } from 'react-router-dom';
import { useNavigation } from '../../../_NavigationContext';
import { useTabState } from '../../../_TabStateContext';

const UITabBlock = ({ 
    tabs, 
    className, 
    hasNavigate = true, 
    componentID = null, 
    preserveTabState = false, 
    onTabChange 
}) =>
{
    const location = useLocation();
    const { navigateSetParam } = useNavigation();
    const { setTabState, getTabState } = useTabState();

    // Initialize activeTab from URL or saved state
    const [activeTab, setActiveTab] = useState(() => 
    {
        if (preserveTabState && componentID)
        {
            return getTabState(componentID, tabs.length, 0);
        }
        return 0;
    });

    // Only sync from URL to state, not the other way around
    useEffect(() =>
    {
        if (!hasNavigate) return;

        const searchParams = new URLSearchParams(location.search);
        const tabParam = searchParams.get('tab');
        const tab = parseInt(tabParam);

        // URL uses 1-based index, so we subtract 1 for internal state
        if (!isNaN(tab) && tab >= 1 && tab <= tabs.length)
        {
            setActiveTab(tab - 1);
        }
        else if (!preserveTabState)
        {
            setActiveTab(0);
        }
    },
    [location.search, tabs.length, hasNavigate, preserveTabState]);

    const handleTabClick = useCallback((index) =>
    {
        setActiveTab(index);

        if (hasNavigate)
        {
            // For URL, we add 1 to convert from 0-based to 1-based index
            navigateSetParam('tab', index === 0 ? null : index + 1);
        }
        
        if (preserveTabState && componentID)
        {
            setTabState(componentID, index, tabs.length);
        }

        if (onTabChange)
        {
            onTabChange(index, tabs[index].label);
        }
    },
    [hasNavigate, preserveTabState, componentID, tabs, navigateSetParam, setTabState, onTabChange]);

    className = mergeClasses('block tabs', className);

    return (
        <div className={className}>
            <div className="tab-tabs">
                <div className="tab-items">
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`tab-item ${index === activeTab ? 'active' : ''} ${tab.className}`}
                            onClick={() => handleTabClick(index)}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
            <div className={`tab-content ${tabs[activeTab] && tabs[activeTab].className}`}>
                <div className="container">
                    {tabs[activeTab] && tabs[activeTab].content}
                </div>
            </div>
        </div>
    );
};

export default UITabBlock;